import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/base.css'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/js/element.js';
import common from './assets/js/common' //工具类
import $post from '@/assets/js/request'
import $get from '@/assets/js/request'

Vue.config.productionTip = false

Vue.use($post);
Vue.use($get);
Vue.use(common);
Vue.use(router);

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
